import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "ph-modal",
  class: "main-wrapper"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_6 = {
  key: 1,
  class: "ph-nav-titles"
}
const _hoisted_7 = { class: "ph-nav-tabs" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 1,
  class: "ph-loading-container"
}
const _hoisted_10 = {
  class: "modal-footer",
  style: {"justify-content":"space-between"}
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

import { useCartStore } from '@/stores/cart'
    import { PropType, onMounted, ref, watch } from 'vue'
    import { ConfigItem, ContractPriceItem, WebsiteItem } from '@/types'
    import { useAppStore } from '@/stores/app'
    import { useModal, Modal } from '@/composables/useModal'
    import PreHangPathSelection from './PreHangPathSelection.vue'
    import usePreHangService from '@/services/pre-hang-service'
    import cartService from '@/services/cart-service'
    import { PreHang } from '@/services/prehang-classes/ph'
    import PreHangTabs from './parts/PreHangTabs.vue'
    import PreHangForm from './forms/PreHangForm.vue'
    import MachineForm from './forms/MachineForm.vue'
    import JambsForm from './forms/JambsForm.vue'
    import LoadingDoorSvg from '../LoadingDoorSvg.vue'
    import { PreHangSelections } from '@/services/prehang-classes/ph-selections'
    import PreHangPrice from './parts/PreHangPrice.vue'
    import ButtonSpinnerComponent from '../ButtonSpinnerComponent.vue'
    import { dispatchUpdateCartCountEvent } from '@/main'
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangModal',
  props: {
      data: { type: Object as PropType<{cartItem: ConfigItem | WebsiteItem | ContractPriceItem}>, required: true},
      isPreHangModalOpen: { type: Boolean, required: true},
      priceAdjust: { type: Number, required: false, default: 100 },
      isCartPage: { type: Boolean, required: false, default: false }
    },
  emits: ['closePreHangModal','preHangSave'],
  setup(__props, { emit: emits }) {

const props = __props

    
  
    
    
    const appStore = useAppStore()
    const cartStore= useCartStore()
    const preHangModal = ref<Modal | null>(null)
    const pathSelection = ref<'prehang'|'machine'|'jambs'>('prehang')
    const ph = ref<PreHang | null>()
    const activeStep = ref<'path'|'prehang'|'machine'|'jambs'>('path')
    const cartReady = ref<boolean>(false)
    const preHangReady = ref<boolean>(false)
    const phService = usePreHangService()
    const isSaving = ref<boolean>(false)
    const baseDoorCount = ref<number>(0)
  
    watch(() => props.isPreHangModalOpen, () => {
      if(props.isPreHangModalOpen) {
        openPreHang()
        const pause = (cartReady.value) ? 10 : 1000
        setTimeout(async () => {
            if(cartStore.cart?.id && props.data.cartItem) {
                ph.value = new PreHang(props.data.cartItem, cartStore.cart?.id)
                isPreHangReady()
                baseDoorCount.value = phService.getPreHangQuantity(props.data.cartItem!.preHangOptions || [], true)
            }
        }, pause)
      } else {
        preHangReady.value = false
        activeStep.value = 'path'
        ph.value = null
      }
    })

    function getAvailableForms() {
        const formList = [...(ph.value?.availableForms || ['prehang','machine','jambs'])]
        if(ph.value?.getActiveSelections().useContractOptions) {
            const index = formList.indexOf('machine')
            if(index > -1) formList.splice(index,1)
        }
        return formList
    }

    function isPreHangReady() {
        if(ph.value?.isLoaded()) {
            const activeForm = ph.value?.getActiveSelections().getActiveForm() || null
            if(activeForm) {
                activeStep.value = activeForm
                if(activeForm == 'machine' || activeForm == 'jambs') {
                    pathSelection.value = activeForm
                }
            }
            preHangReady.value = true
        } else {
            setTimeout(() => {
                isPreHangReady()
            }, 100)
        }
    }
  
    function openPreHang() {
        preHangModal.value?.show()
    }

    function updatePh() {
        ph.value?.updateCartPreHangOptions()
    }

    function getDoorHeight() {
        const door = props.data.cartItem as WebsiteItem
        const height = door.custom_height || parseInt(door.height_text) || null
        return (height as number)
    }

    async function savePreHang() {
        isSaving.value = true
        const data: any = {
            ...props.data.cartItem
        }
        data.preHangQuantities = []
        data.preHangOptions = ph.value?.cartPreHangOptions

        let userConfirmation = true
        const phDoorQty = phService.getPreHangQuantity(data.preHangOptions, true);
        const phUnitQty = phService.getPreHangQuantity(data.preHangOptions, false);
        // DoorQty == 0 signifies being on a product page
        if(baseDoorCount.value > 0 && phDoorQty > baseDoorCount.value) {
            userConfirmation = confirm(`Installation selections added ${phDoorQty - baseDoorCount.value} doors. Is this correct?`)
            data.quantity = phUnitQty
        }

        if(userConfirmation) {
            try {
                const itemResult = (props.isCartPage) ? await updateCartItem(phDoorQty > baseDoorCount.value, data) : await addCartItem(data, phUnitQty)
                const phResult = await cartService.updatePreHang(data)
                
                if(phResult) {
                    const response = (props.isCartPage) ? phResult : phDoorQty
                    emits('preHangSave', response)
                    preHangModal.value?.hide()
                    emits('closePreHangModal');
                }
            } catch(err) {
                console.log("Error saving prehang form.")
                console.log(err)
            }
        }
        isSaving.value = false
    }

    async function updateCartItem(updateQuantity: boolean, door: WebsiteItem | ConfigItem | ContractPriceItem) {
        let result
        try {
            const updateResult = (updateQuantity) ? await cartService.updateQuantity(door, door.quantity) : ''
            result = updateResult
        } catch (err) {
            console.log("Error during updateCartItem:", err)
            result = false
        }
        return result
    }

    async function addCartItem(door: WebsiteItem | ConfigItem | ContractPriceItem, qty: number) {
        let result
        try {
            const addResult = await cartService.addItem(door, qty)
            result = addResult
            dispatchUpdateCartCountEvent()
        } catch (err) {
            console.log("Error during addCartItem:", err)
            result = false
        }
        return result
    }
    
    onMounted(async () => {
        appStore.loadingWhile(async () => {
            await cartStore.get()
            cartReady.value = true
        })
    })

    function updatePath(path: 'path'|'prehang'|'machine'|'jambs') {
        const activePh = ph.value?.getActiveSelections()
        const phPath = activePh?.getActiveForm()
        if(path != phPath) {
            activePh?.updateActiveForm(path)
        }
        activeStep.value = path
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal fade",
      ref: el => preHangModal.value = _unref(useModal)(el as Element),
      tabindex: "-1",
      "aria-hidden": "true",
      "data-bs-backdrop": "static"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (activeStep.value == 'path')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Installation Type"))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (ph.value?.availableForms.includes('prehang'))
                    ? (_openBlock(), _createElementBlock("h2", {
                        key: 0,
                        class: _normalizeClass({'active':activeStep.value == 'prehang'}),
                        onClick: _cache[0] || (_cache[0] = () => updatePath('prehang'))
                      }, "Prehang", 2))
                    : _createCommentVNode("", true),
                  (ph.value?.availableForms.includes('machine') && !ph.value?.getActiveSelections().useContractOptions)
                    ? (_openBlock(), _createElementBlock("h2", {
                        key: 1,
                        class: _normalizeClass({'active':activeStep.value == 'machine'}),
                        onClick: _cache[1] || (_cache[1] = () => updatePath('machine'))
                      }, "Machine", 2))
                    : _createCommentVNode("", true),
                  (ph.value?.availableForms.includes('jambs'))
                    ? (_openBlock(), _createElementBlock("h2", {
                        key: 2,
                        class: _normalizeClass({'active':activeStep.value == 'jambs'}),
                        onClick: _cache[2] || (_cache[2] = () => updatePath('jambs'))
                      }, "Jambs", 2))
                    : _createCommentVNode("", true)
                ])),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(PreHangTabs, {
                "active-tab": ph.value?.getActiveIndex(),
                prehangs: [...(ph.value?.preHangSelections || [])],
                onNewTab: _cache[3] || (_cache[3] = () => {ph.value?.addNewPreHang()}),
                onChangeTab: _cache[4] || (_cache[4] = (i) => {ph.value?.updateActiveIndex(i); updatePath(ph.value?.getActiveForm() || 'path')})
              }, null, 8, ["active-tab", "prehangs"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "button-close",
              "aria-label": "Close",
              onClick: _cache[5] || (_cache[5] = () => {preHangModal.value?.hide(); emits('closePreHangModal');})
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (preHangReady.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (activeStep.value == 'path')
                    ? (_openBlock(), _createBlock(PreHangPathSelection, {
                        key: 0,
                        "path-selection": pathSelection.value,
                        "onUpdate:path-selection": _cache[6] || (_cache[6] = ($event: any) => ((pathSelection).value = $event)),
                        "available-forms": getAvailableForms(),
                        onConfirmPath: _cache[7] || (_cache[7] = () => updatePath(pathSelection.value))
                      }, null, 8, ["path-selection", "available-forms"]))
                    : (activeStep.value == 'prehang')
                      ? (_openBlock(), _createBlock(PreHangForm, {
                          key: 1,
                          ph: (ph.value?.getActiveSelections() as PreHangSelections),
                          onUpdatePreHang: updatePh
                        }, null, 8, ["ph"]))
                      : (activeStep.value == 'machine')
                        ? (_openBlock(), _createBlock(MachineForm, {
                            key: 2,
                            ph: (ph.value?.getActiveSelections() as PreHangSelections),
                            "door-height": getDoorHeight(),
                            onUpdatePreHang: updatePh
                          }, null, 8, ["ph", "door-height"]))
                        : (activeStep.value == 'jambs')
                          ? (_openBlock(), _createBlock(JambsForm, {
                              key: 3,
                              ph: (ph.value?.getActiveSelections() as PreHangSelections),
                              onUpdatePreHang: updatePh
                            }, null, 8, ["ph"]))
                          : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(LoadingDoorSvg)
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (activeStep.value == 'path')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-default",
                    onClick: _cache[8] || (_cache[8] = () => {preHangModal.value?.hide(); emits('closePreHangModal');})
                  }, "Cancel"),
                  (preHangReady.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[9] || (_cache[9] = () => updatePath(pathSelection.value))
                      }, "Next"))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-default",
                    onClick: _cache[10] || (_cache[10] = () => updatePath('path'))
                  }, "Back"),
                  _createVNode(PreHangPrice, {
                    door: props.data.cartItem,
                    "pre-hang-options": ph.value?.cartPreHangOptions || [],
                    "price-adjust": props.priceAdjust
                  }, null, 8, ["door", "pre-hang-options", "price-adjust"]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: savePreHang,
                    disabled: isSaving.value || (ph.value?.getActiveErrors() || []).length > 0 || ph.value?.getActiveIsEmpty()
                  }, [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(ButtonSpinnerComponent, {
                          key: 0,
                          visible: isSaving.value
                        }, null, 8, ["visible"]))
                      : (props.isCartPage)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Save"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "Add to Cart"))
                  ], 8, _hoisted_11)
                ], 64))
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})